<script setup lang="ts">
import type { Customer } from '@/types'
import { Head, Link } from '@inertiajs/vue3'
import CustomerForm from '@/components/customers/CustomerForm.vue'
import { dashboardLayout } from '@/lib/layouts'
import { adminCustomerPath } from '@/routes'

defineOptions({
  layout: dashboardLayout,
})

const props = defineProps<{
  customer: Customer
}>()

const title = `Edit ${props.customer.name}`
</script>

<template>
  <Head :title="title" />

  <UDashboardPanel id="customer-edit">
    <template #header>
      <UDashboardNavbar title="Edit customer">
        <template #leading>
          <UButton
            :to="adminCustomerPath(customer.id)"
            :as="Link"
            icon="i-lucide-arrow-left"
            color="neutral"
            variant="ghost"
            square
          />
        </template>
      </UDashboardNavbar>
    </template>

    <template #body>
      <CustomerForm
        :customer="customer"
        :action="adminCustomerPath(customer.id)"
        method="patch"
        submit-label="Save changes"
      />
    </template>
  </UDashboardPanel>
</template>
